import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {
    HttpClient,
    HttpEventType,
    HttpHeaders,
    HttpRequest,
} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {IFileUploadObject} from './file-upload-object.interface';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import { FormControl } from '@angular/forms';
import { FileUploaderErrorsEnum } from '../../interfaces/FileUploaderErrorsEnum';

@UntilDestroy()
@Component({
    selector: 'app-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent {
    @Input() autoUpload: boolean;
    @Input() dropFilesText: string;
    @Input() link: string;
    @Input() accept: string = 'all';
    @Input() heightInRem: number;
    @Input() multiple: boolean;

    @Input() error: FileUploaderErrorsEnum = FileUploaderErrorsEnum.None;

    @Output() afterFileSelected: EventEmitter<IFileUploadObject[]> = new EventEmitter();

    selectedFiles: IFileUploadObject[] = [];

    dropzoneHovered: boolean;

    FileUploaderErrorsEnum = FileUploaderErrorsEnum;

    @ViewChild('fileInput') fileInput: ElementRef;

    constructor(
        private http: HttpClient,
    ) {
    }

    cancel(ev): void {
       ev.stopPropagation();
    }

    dropFiles(ev): void {
        // Prevent default behavior (file from being opened)
        ev.preventDefault();
        if (ev.dataTransfer.items) {
            this.error = FileUploaderErrorsEnum.None;
            if(ev.dataTransfer.items.length > 1 && !this.multiple) {
                this.error = FileUploaderErrorsEnum.MultipleFilesNotAllowed;
                return;   
            }

            // tslint:disable-next-line
            for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind === 'file') {
                  const file = ev.dataTransfer.items[i].getAsFile();
                  this.emitSelectedFile(file);
                }
            }
        }

        this.dropzoneHovered = false;
    }

    clearName(): void {
        this.fileInput.nativeElement.value = '';
    }

    afterFilesSelected(ev): void {
        if (ev?.target?.files?.length) {
            // tslint:disable-next-line
            for (let i = 0; i < ev.target.files.length; i++) {
                //this.pushFileToList(ev.target.files[i]);
                this.emitSelectedFile(ev.target.files[i]);
            }
        }
    }

    dragOverHandler(ev): void {
        ev.preventDefault();
        ev.stopPropagation();
    }

    getErrorMessage(): string {
        switch(this.error) {
            case FileUploaderErrorsEnum.InvalidFormat: return 'Unable to process the file.  Please make sure the file matches the correct format.';
            case FileUploaderErrorsEnum.InvalidFile: return 'File has no valid headers.';
            case FileUploaderErrorsEnum.MultipleFilesNotAllowed: return 'You can only drop one file!'; 
        }  
    }

    private emitSelectedFile(file): void {
        const obj = {
            id: null,
            name: `${file.name}`,
            selectedFile: file,
            fileId: `${file.name}-${file.lastModified}`,
            uploadCompleted: false,
            uploadedPercent: 0,
        };

        this.afterFileSelected.emit(<any>obj);
    }
}
